import React, { Component } from "react";
import "./tipocambio.css";
import { toast } from "react-toastify";
import { DatePicker } from "react-rainbow-components";
import { getTipoCambio } from "../../../service/api";
import SpinnerModal from "../../spiner/SpinnerModal";

export default class TipoCambioModal extends Component {
  state = {
    loading: false,
    saving: false,

    fecha: "",
    tipoCambio: "",

    originalTipoCambio: "",
    editadoGeneral: 0, //  SOLO si el usuario cambia el general

    locaciones: [],
    sortKey: "nombre",
    sortDir: "asc",
  };

  componentDidUpdate(prevProps) {
    const openedNow = !prevProps.show && this.props.show;
    if (openedNow) {
      const hoy = this.toISODate(new Date());
      this.resetAndFetch(hoy);
    }
  }

  resetAndFetch = (fechaISO) => {
    this.setState(
      {
        loading: true,
        saving: false,

        fecha: fechaISO,
        tipoCambio: "",
        originalTipoCambio: "",
        editadoGeneral: 0,

        locaciones: [],
        sortKey: "nombre",
        sortDir: "asc",
      },
      () => this.fetchTipoCambio(fechaISO)
    );
  };

  // ---------- helpers ----------
  toISODate = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  parseISOToDate = (iso) => {
    if (!iso) return new Date();
    const [y, m, d] = iso.split("-").map(Number);
    return new Date(y, (m || 1) - 1, d || 1);
  };

  allowDecimal = (value) => /^\d*([.]\d*)?$/.test(value);

  //  editadoGeneral SOLO refleja si cambió el input general
  recomputeEditadoGeneral = (tipoCambio, originalTipoCambio) => {
    const changed =
      String(tipoCambio ?? "").trim() !== String(originalTipoCambio ?? "").trim();
    return changed ? 1 : 0;
  };

  rowChanged = (x) => {
    if (!x) return false;
    const enabledChanged = !!x.enabled !== !!x.originalEnabled; // 🔥 si apagaste uno que venía ON, cuenta como cambio
    const valueChangedWhileEnabled =
      !!x.enabled && String(x.valor ?? "").trim() !== String(x.originalValor ?? "").trim();
    return enabledChanged || valueChangedWhileEnabled;
  };

  hasAnyChange = () => {
    const { editadoGeneral, locaciones } = this.state;
    const anyRowChange = (locaciones || []).some((x) => this.rowChanged(x));
    return Number(editadoGeneral) === 1 || anyRowChange;
  };

  canSave = () => {
    const { loading, saving, fecha, tipoCambio } = this.state;
    if (loading || saving) return false;

    const f = String(fecha || "").trim();
    const generalStr = String(tipoCambio || "").trim();

    if (!f) return false;
    if (!generalStr) return false;
    if (!this.hasAnyChange()) return false;

    return true;
  };

  // ---------- orden ----------
  sortBy = (key) => {
    this.setState((prev) => {
      const nextDir = prev.sortKey === key && prev.sortDir === "asc" ? "desc" : "asc";
      const sorted = [...prev.locaciones].sort((a, b) => {
        const va = String(a?.[key] ?? "").toLowerCase();
        const vb = String(b?.[key] ?? "").toLowerCase();
        if (va < vb) return nextDir === "asc" ? -1 : 1;
        if (va > vb) return nextDir === "asc" ? 1 : -1;
        return 0;
      });
      return { locaciones: sorted, sortKey: key, sortDir: nextDir };
    });
  };

  // ---------- fecha ----------
  setHoy = () => {
    if (this.state.loading || this.state.saving) return;
    const hoy = this.toISODate(new Date());
    if (hoy === this.state.fecha) return;
    this.resetAndFetch(hoy);
  };

  onChangeFecha = (dateObj) => {
    if (!dateObj || this.state.loading || this.state.saving) return;
    const fechaISO = this.toISODate(dateObj);
    if (fechaISO === this.state.fecha) return;
    this.resetAndFetch(fechaISO);
  };

  // ---------- general ----------
  onChangeTipoCambio = (e) => {
    const v = e.target.value;
    if (!this.allowDecimal(v)) return;

    this.setState((prev) => {
      const nextTipo = v;

      //  Si una locación NO está habilitada, SIEMPRE toma el general
      const nextLocs = (prev.locaciones || []).map((x) => {
        if (x.enabled) return x;
        return {
          ...x,
          valor: nextTipo,
          originalValor: nextTipo,
          editado: 0,
        };
      });

      return {
        tipoCambio: nextTipo,
        locaciones: nextLocs,
        editadoGeneral: this.recomputeEditadoGeneral(nextTipo, prev.originalTipoCambio),
      };
    });
  };

  // ---------- locaciones ----------
  toggleLocEnabled = (idlocacion) => {
    if (this.state.loading || this.state.saving) return;
  
    this.setState((prev) => {
      const generalNow = String(prev.tipoCambio ?? "");
  
      const nextLocs = prev.locaciones.map((x) => {
        if (x.idlocacion !== idlocacion) return x;
  
        const nextEnabled = !x.enabled;
  
        if (!nextEnabled) {
          // apagar => toma general, se limpia badge
          return {
            ...x,
            enabled: false,
            valor: generalNow,
            // mantenemos originalValor como baseline de API (NO lo cambies),
            // para que rowChanged siga detectando que hubo un toggle
            editado: 0,
          };
        }
  
        // encender => override activo
        return { ...x, enabled: true, editado: 1 };
      });
  
      return {
        locaciones: nextLocs,
        editadoGeneral: this.recomputeEditadoGeneral(prev.tipoCambio, prev.originalTipoCambio),
      };
    });
  };

  onChangeLocValor = (idlocacion, value) => {
    if (!this.allowDecimal(value)) return;
  
    this.setState((prev) => {
      const nextLocs = prev.locaciones.map((x) => {
        if (x.idlocacion !== idlocacion) return x;
  
        const newVal = value;
  
        //  si está habilitada => override => editado=1 siempre
        if (x.enabled) return { ...x, valor: newVal, editado: 1 };
  
        // si no está habilitada, ni debería poder editar, pero por seguridad:
        return { ...x, valor: newVal, editado: 0 };
      });
  
      return {
        locaciones: nextLocs,
        editadoGeneral: this.recomputeEditadoGeneral(prev.tipoCambio, prev.originalTipoCambio),
      };
    });
  };

  // ---------- API GET ----------
  fetchTipoCambio = async (fechaISO) => {
    try {
      const r = await getTipoCambio({ fecha: fechaISO });

      if (r?.code === 2003) {
        toast.info("Sesión expirada. Inicia sesión nuevamente.");
        this.setState({ loading: false });
        this.props.onClose?.();
        this.props.onLogout?.();
        return;
      }

      if (r?.code !== 0) {
        this.setState({
          loading: false,
          tipoCambio: "",
          originalTipoCambio: "",
          editadoGeneral: 0,
          locaciones: [],
        });
        toast.info(`${r?.code} - ${r?.message || "No se pudo obtener el tipo de cambio."}`);
        return;
      }

      const data = r?.data || {};
      const fecha = data?.fecha || fechaISO;
      const tipoCambio = String(data?.tipocambio ?? "");
      const list = Array.isArray(data?.locaciones) ? data.locaciones : [];

      const locaciones = list.map((it) => {
        const val = String(it?.tipocambio ?? "");
        const editadoApi = Number(it?.editado) === 1 ? 1 : 0;
        const enabledApi = editadoApi === 1;

        return {
          idlocacion: it?.idlocacion,
          nombre: it?.locacion || "Locación",

          valor: val,
          originalValor: val,

          editado: editadoApi,

          enabled: enabledApi,

          //  baseline de API para detectar "quité el editado"
          originalEditado: editadoApi,
          originalEnabled: enabledApi,
        };
      });

      locaciones.sort((a, b) =>
        String(a.nombre).localeCompare(String(b.nombre), "es", { sensitivity: "base" })
      );

      //  AL ABRIR: general NO sale editado
      this.setState({
        fecha,
        tipoCambio,
        originalTipoCambio: tipoCambio,
        editadoGeneral: 0,
        locaciones,
        loading: false,
        sortKey: "nombre",
        sortDir: "asc",
      });
    } catch (e) {
      this.setState({
        loading: false,
        tipoCambio: "",
        originalTipoCambio: "",
        editadoGeneral: 0,
        locaciones: [],
      });
      toast.info("No se pudieron cargar las locaciones.");
    }
  };

  resetEditsUI = () => {
    this.setState((prev) => {
      const generalNow = String(prev.tipoCambio ?? "");
      return {
        originalTipoCambio: generalNow,
        editadoGeneral: 0,
        locaciones: (prev.locaciones || []).map((x) => ({
          ...x,
          // al “limpiar” dejamos todo siguiendo general y sin overrides
          enabled: false,
          editado: 0,
          valor: generalNow,
          originalValor: generalNow,

          originalEnabled: false,
          originalEditado: 0,
        })),
      };
    });
  };

  // ---------- Guardar ----------
  onSave = async () => {
    const { loading, saving, fecha, tipoCambio, locaciones, originalTipoCambio } = this.state;
    if (loading || saving) return;
    if (!this.hasAnyChange()) return;
  
    const f = String(fecha || "").trim();
    const generalStr = String(tipoCambio || "").trim();
    if (!f) return toast.info("Selecciona una fecha.");
    if (!generalStr) return toast.info("Ingresa el tipo de cambio general.");
  
    const generalNow = Number(generalStr);
  
    //  SOLO ENABLED se envían
    const enabledRows = (locaciones || []).filter((x) => !!x.enabled);
  
    // valida SOLO los enabled
    for (const row of enabledRows) {
      if (!String(row.valor || "").trim()) {
        return toast.info(`Falta el tipo de cambio en: ${row.nombre}`);
      }
    }
  
    const editadoGeneral = this.recomputeEditadoGeneral(tipoCambio, originalTipoCambio);
  
    const payload = {
      fecha: f,
      valor: generalNow,
      editado: Number(editadoGeneral),
      locacion: enabledRows.map((x) => ({
        idlocacion: x.idlocacion,
        valor: Number(x.valor),
      })),
    };
  
    this.setState({ saving: true });
  
    try {
      const resp = await this.props.onSave?.(payload);
      if (resp?.code === 2003) return;
      if (resp?.code !== 0) return;
  
      this.setState({ loading: true });
      await this.fetchTipoCambio(f);
    } finally {
      this.setState({ saving: false, loading: false });
    }
  };

  render() {
    const { show, onClose } = this.props;
    const { loading, saving, fecha, tipoCambio, locaciones, editadoGeneral } = this.state;

    if (!show) return null;

    const busy = loading || saving;
    const guardarEnabled = this.canSave();

    return (
      <div className="tc-backdrop" role="dialog" aria-modal="true">
        <div className="tc-modal" onMouseDown={(e) => e.stopPropagation()}>
          {busy ? <SpinnerModal tipo="full" show={busy} /> : null}

          <div className="tc-head">
            <h3 className="tc-title">Tipo de cambio</h3>
            <button type="button" className="tc-x" onClick={onClose} disabled={busy} aria-label="Cerrar">
              ✕
            </button>
          </div>

          <div className="tc-body">
            <div className="v-datetc">
              <label className="tc-label">
                <strong>Fecha:</strong>
              </label>

              <button type="button" className="v-btnHoy" onClick={this.setHoy} disabled={busy}>
                Hoy
              </button>

              <DatePicker
                id="tipo-cambio-date"
                value={this.parseISOToDate(fecha)}
                onChange={this.onChangeFecha}
                formatStyle="large"
                placeholder="Selecciona fecha"
                disabled={busy}
              />
            </div>

            <div className="tc-field">
              <label className="tc-label">
                Tipo de cambio general:
                {Number(editadoGeneral) === 1 ? (
                  <span className="tc-badgeEdit" style={{ marginLeft: 8 }}>
                    Editado
                  </span>
                ) : null}
              </label>

              <input
                className="tc-input"
                value={tipoCambio}
                onChange={this.onChangeTipoCambio}
                placeholder="0.00"
                inputMode="decimal"
                disabled={busy}
              />
            </div>

            <div className="tc-list">
              <div className="tc-list__head">
                <button type="button" className="tc-th tc-th--click" onClick={() => this.sortBy("nombre")} disabled={busy}>
                  Locación
                </button>

                <div className="tc-th">Tipo cambio</div>
                <div className="tc-th tc-th--center">Individual</div>
              </div>

              {locaciones.length === 0 ? (
                <div className="tc-empty">{loading ? "Cargando..." : "Sin locaciones"}</div>
              ) : (
                <div className="tc-list__scroll">
                  {locaciones.map((x) => (
                    <div className="tc-row" key={x.idlocacion}>
                      <div className="tc-name">
                        {x.nombre}
                        {Number(x.editado) === 1 ? <span className="tc-badgeEdit">Editado</span> : null}
                      </div>

                      <input
                        className="tc-rowinput"
                        value={x.valor}
                        onChange={(e) => this.onChangeLocValor(x.idlocacion, e.target.value)}
                        placeholder="0.00"
                        inputMode="decimal"
                        disabled={busy || !x.enabled}
                      />

                      <label className="tc-check">
                        <input
                          type="checkbox"
                          checked={!!x.enabled}
                          onChange={() => this.toggleLocEnabled(x.idlocacion)}
                          disabled={busy}
                        />
                      </label>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="tc-foot">
            <button type="button" className="tc-btn tc-btn--ghost" onClick={onClose} disabled={busy}>
              Cancelar
            </button>

            <button
              type="button"
              className={!guardarEnabled ? "tc-btn tc-btn--ghost" : "tc-btn tc-btn--primary"}
              onClick={this.onSave}
              disabled={!guardarEnabled}
              title={!guardarEnabled ? "No hay cambios para guardar" : "Guardar cambios"}
            >
              {saving ? "Guardando..." : "Guardar"}
            </button>
          </div>
        </div>
      </div>
    );
  }
}